// extracted by mini-css-extract-plugin
export default {"container":"xsBYmg","navigation":"dRKUKd","homeLink":"nt3Pz3"};